import * as DisableStateActions from '../actions/disabled';

export interface State {
	neo: boolean;
	xena: boolean;
	rentalCar: boolean;
	bedsAndMore: boolean;
	urlaubsidee: boolean;
}

export const InitialState: State = {
	neo: false,
	xena: false,
	rentalCar: false,
	bedsAndMore: false,
	urlaubsidee: true,
};

export function reducer(state: State = InitialState, action: DisableStateActions.All): State {
	switch (action.type) {
		case DisableStateActions.DISABLE:
			if (Array.isArray(action.app)) {
				let newState = state;
				action.app.forEach(app => {
					newState = {...newState, [app]: true};
				});

				return newState;
			}

			return {...state, [action.app]: true};

		case DisableStateActions.ENABLE:
			if (Array.isArray(action.app)) {
				let newState = state;

				action.app.forEach(app => {
					newState = {...newState, [app]: false};
				});

				return newState;
			}

			return {...state, [action.app]: false};

		default:
			return state;
	}
}

export const neoDisabledState = (s: State): boolean => s.neo;
export const xenaDisabledState = (s: State): boolean => s.xena;
export const urlaubsIdeeDisabledState = (s: State): boolean => s.urlaubsidee;
export const hideXenaNeoStwitch = (s: State): boolean => s.xena === true || s.neo === true;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/reducers/disabled.ts